<div class="container-fluid">
    <bds-fastrac-design-display
        [gridId]="gridId"
        [fastracId]="fastracId"
        [showFastrac]="showFastrac"
        (showFastracChange)="onFastracVisibleChanged($event)"
        (fastracIdChange)="onFastracIdChanged($event)"
        (fastracDesignsChange)="onFastracDesignsChanged($event)"
        (applyFastrac)="onApplyFastrac($event)"
    >
    </bds-fastrac-design-display>
</div>
<bds-grid-details>
    <ng-container grid>
        <bds-fastrac-dx-grid-wrapper
            #dxGridWrapper
            bdsGridDetails
            bds-grid
            #bdsJeopardizedShipmentGrid
            [selectionMode]="gridMode ?? 'multiple'"
            (bdsMenuItemClicked)="onMenuItemClicked($event)"
            id="bdsJeopardizedShipmentGrid"
            [dataSource]="gridSource"
            height="85vh"
            minHeight="200px"
            [(selectedRowKeys)]="selectedRowKeys"
            (onSelectionChanged)="selectionChanged($event)"
            (onContentReady)="gridInitialized()"
            [bdsAllowCloneRecords]="true"
            (bdsCloneRecordsClicked)="copyCarsToClipboard()"
            bdsCloneRecordsHint="Copy cars"
            [gridId]="gridId"
            [fastracId]="fastracId"
            [fastracDesign]="currentFastrac"
            [bdsFastracDesignList]="fastracList"
            (bdsShowFastrac)="onShowFastrac()"
            (fastracIdChange)="onGridFastracIdChanged($event)"
            [bdsCustomizeColumns]="customizeColumns"
        >
        </bds-fastrac-dx-grid-wrapper>
    </ng-container>
    <ng-container details>
        <mat-tab-group *ngIf="selectedRowKeys?.length > 1">
            <mat-tab label="Multi Select Detail">
                <ng-template matTabContent>
                    <rt-multi-trip
                        *ngIf="selectedRowKeys?.length > 1"
                        [tripIds]="tripIds"
                        [isReadOnly]="isReadonly"
                        [tripRefFieldDefs$]="tripRefFieldDefs$"
                        [clearNoBillCLMEvent]="selectedRowKeys[0]?.reason === 'NO BILLS'"
                    ></rt-multi-trip>
                </ng-template>
            </mat-tab>
            <mat-tab *ngFor="let key of selectedRowKeys" [label]="tabLabelString(key)">
                <ng-template matTabContent>
                    <rt-jeopardized-shipment-reason
                        [shipment]="key"
                        [resolved]="resolved"
                        [addTripRouterLink]="['/trip', 0]"
                        (change)="shipmentChanged(key)"
                        (popoutTrip)="onPopoutTrip($event)"
                    ></rt-jeopardized-shipment-reason>
                </ng-template>
            </mat-tab>
        </mat-tab-group>

        <ng-container *ngIf="selectedRowKeys?.length === 1">
            <div *ngFor="let key of selectedRowKeys">
                <rt-jeopardized-shipment-reason
                    [shipment]="key"
                    [resolved]="resolved"
                    [addTripRouterLink]="['/trip', 0]"
                    (change)="shipmentChanged(key)"
                    (popoutTrip)="onPopoutTrip($event)"
                ></rt-jeopardized-shipment-reason>
            </div>
        </ng-container>
    </ng-container>
</bds-grid-details>
